/* RESPONSIBLE TEAM: team-inbox-experience */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import type Inbox from './inbox';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
import { InboxType } from 'embercom/models/data/inbox/inbox-types';
import { NamedIcon } from '../command-k/icons';

export type MentionsInboxWireFormat = {
  inbox_type: InboxType.Mentions;
  count: number;
};

export default class Mentions implements Inbox {
  readonly id = 'mentions';
  readonly category = InboxCategory.Shared;
  readonly type = InboxType.Mentions;
  readonly count?: number;

  name = 'Mentions';

  readonly translationKey = 'inbox.inbox-list.mentions';

  icon = new NamedIcon('mention');

  constructor(count: number) {
    this.count = count;
  }

  static deserialize(json: MentionsInboxWireFormat): Mentions {
    return new Mentions(json.count);
  }
}
